module.exports = __webpack_public_path__ + "img/noticia4.69d53165.png";